<div *ngIf="formGroup" [formGroup]="formGroup">
  <div class="row">
    <div class="col-12 mb-custom-checkbox"
         data-cy="mb-billing-sales-tax">
      <input id="taxExempt"
             type="checkbox"
             name="taxExempt"
             [checked]="address.taxExempt"
             (change)="setTaxExemptionValue()"
             data-cy="mb-billing-address-sales-tax-input"/>
      <label for="taxExempt"
             class="mb-custom-label"
             [innerHTML]="'address.us.salesTaxExemption' | cxTranslate"></label>
    </div>
    <div class="col-9 mt-2 mb-checkout-sales-tax-text"
         data-cy="mb-checkout-sales-tax-text"
         [innerHTML]="'address.us.salesTaxExemptionText' | cxTranslate">
    </div>
  </div>
</div>
